jQuery(function($) { // jQuery init

	var panel = $('.collapsible-panel');

	panel.find('> .clps-item > .clps-header').on('click', function() {
		var $this = $(this);
		var $sibs = $this.parent('.clps-item').siblings();

		$sibs.removeClass('active').find('> .clps-content').slideUp('fast');

		// simple but can leak
		// $this.parent('.clps-item').toggleClass('active');
		// $this.next('.clps-content').slideToggle('fast');

		// explicit and safe
		if ( !$this.parent('.clps-item').hasClass('active') && !$this.next('.clps-content').is(':visible') ) {
			$this.parent('.clps-item').addClass('active');
			$this.next('.clps-content').slideDown('fast');
		} else {
			$this.parent('.clps-item').removeClass('active');
			$this.next('.clps-content').slideUp('fast');
		}

		

	});

});